import { defineStore } from "pinia";
import { getMenus, SUPPLYVET_CHANNEL, ESUPPLYVET_CHANNEL } from "@/api/menus";
import esupplyvetApi from "@/api/esupplyvet";

export const useMenusStore = defineStore("menus", {
  state: () => ({
    menus: [],
    menuItems: [],
    firstcall: true,
    loading: false,
    error: null,
    channel: SUPPLYVET_CHANNEL,
  }),

  getters: {
    /**
     * Retourne les items de menu triés par position et formatés pour l'affichage
     */
    sortedMenuItems: state => {
      return state.menuItems
        .slice()
        .sort((a, b) => a.position - b.position)
        .map(item => ({
          ...item,
          children: item.children ? item.children.slice().sort((a, b) => a.position - b.position) : [],
        }));
    },

    /**
     * Retourne le nombre total d'items de menu
     */
    menuItemsCount: state => {
      return state.menuItems.length;
    },

    /**
     * Vérifie si les menus sont en cours de chargement
     */
    isLoading: state => {
      return state.loading;
    },

    /**
     * Retourne l'erreur s'il y en a une
     */
    hasError: state => {
      return state.error !== null;
    },
  },

  actions: {
    /**
     * Récupère les menus depuis l'API
     * @param {string} channel - Code du channel à filtrer
     */
    async fetchMenus(channel = SUPPLYVET_CHANNEL) {
      if (this.firstcall) this.loading = true;
      this.error = null;
      this.channel = channel;

      try {
        let response;

        // Choisir la bonne API selon le channel
        if (channel === ESUPPLYVET_CHANNEL) {
          response = await getMenus(channel, esupplyvetApi);
        } else {
          response = await getMenus(channel);
        }

        this.menus = response.data;
        const targetMenu = this.menus.find(menu => menu.channel && menu.channel.code === channel);

        if (targetMenu && targetMenu.items) {
          this.menuItems = targetMenu.items;
        } else {
          this.menuItems = [];
          console.warn(`Aucun menu trouvé pour le channel: ${channel}`);
        }

        if (this.firstcall) {
          this.firstcall = false;
          this.loading = false;
        }
      } catch (error) {
        this.error = "Erreur lors du chargement des menus";
        this.loading = false;
        console.error("Erreur fetchMenus:", error);
      }
    },

    /**
     * Réinitialise l'état du store
     */
    resetStore() {
      this.menus = [];
      this.menuItems = [];
      this.firstcall = true;
      this.loading = false;
      this.error = null;
    },

    /**
     * Change le channel et recharge les menus
     * @param {string} newChannel - Nouveau channel
     */
    async changeChannel(newChannel) {
      this.channel = newChannel;
      this.resetStore();
      await this.fetchMenus(newChannel);
    },
  },

  persist: true,
});
